'use strict';

angular.module('supervisorAuthorizingUserRequestControllers')

.controller('NotAvailableController', ['$scope', 'userRequestToAuthorize', function ($scope, userRequestToAuthorize) {

    $scope.request = userRequestToAuthorize.Request;

}]);